module.exports = __webpack_public_path__ + "static/media/Screenshot_8.bcfbbd2b.png";